import React from "react";
import NavMenu from "../../composant/NavMenu";
import fotoNathalie from "../../assets/images/Nathalie.jpg";

export default function PaginaInstitucional() {
  return (
    <div className="bg-gray-50 text-gray-800 text-lg leading-relaxed">
      <NavMenu />

      {/* HERO */}
      <section className="bg-navy text-white">
        <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* FOTO */}
          <div className="flex justify-center md:justify-start">
            <img
              src={fotoNathalie}
              alt="Dra. Nathalie Guimarães dos Santos"
              className="rounded-2xl shadow-xl w-full max-w-md object-cover"
            />
          </div>

          {/* TEXTO HERO */}
          <div>
            <h1 className="text-5xl md:text-6xl font-bold leading-tight mb-6">
              Advocacia Estratégica e Humanística
            </h1>
            <p className="text-2xl md:text-3xl text-gray-700">
              Prevenção e Defesa com Responsabilidade Social
            </p>
          </div>
        </div>
      </div>
      </section>

      {/* QUEM SOU EU */}
      <section className="max-w-5xl mx-auto px-6 py-16">
        <h2 className="text-4xl font-bold mb-8">Quem Sou Eu</h2>

        <p className="text-xl leading-8 mb-6">
          Com uma trajetória sólida de 10 anos de atuação nos tribunais, minha prática jurídica une o rigor técnico do contencioso à visão humanística necessária para resolver conflitos complexos.
        </p>

        <p className="text-xl leading-8 mb-6">
          Graduada pela FMU e inscrita na OAB/SP desde 2015, acumulo a experiência de mais de 400 demandas nas esferas cível e criminal, defendendo os interesses de pessoas físicas, coletivos e empresas.
        </p>

        <p className="text-xl leading-8 mb-10">
          Acredito em uma advocacia fundada na responsabilidade social, transformando a experiência em tribunal em ferramentas de governança e prevenção de riscos.
        </p>

        <h3 className="text-3xl font-semibold mb-6">Especialidade em Compliance Penal e Governança</h3>

        <ul className="list-disc pl-6 space-y-4 text-xl">
          <li>Compliance Penal Familiar e Escolar</li>
          <li>Compliance Penal para Profissionais da Saúde</li>
          <li>Compliance para Influenciadores Digitais e Figuras Públicas</li>
          <li>Compliance Penal para Profissionais Liberais e Consultores</li>
          <li>Compliance e Governança em Planejamento Sucessório</li>
          <li>Compliance de Integridade Esportiva</li>
          <li>Governança Condominial</li>
          <li>Compliance Empresarial</li>
        </ul>
      </section>

      {/* EDUCAÇÃO LEGAL */}
      <section className="bg-white py-16">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold mb-8">Educação Legal e Conscientização Estratégica</h2>

          <p className="text-xl leading-8 mb-6">
            Acredito que a informação é a ferramenta de prevenção mais eficaz. Por isso, atuo também por meio de palestras, workshops e treinamentos customizados.
          </p>

          <ul className="list-disc pl-6 space-y-4 text-xl">
            <li>Educação Legal nas Escolas</li>
            <li>Treinamentos Corporativos</li>
            <li>Capacitação em Condomínios</li>
            <li>Direito para Grupos Vulneráveis</li>
          </ul>
        </div>
      </section>

      {/* ARTIGOS JURÍDICOS */}
      <section id="artigos" className="bg-gray-100 py-20">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">Artigos Jurídicos</h2>
          <p className="text-xl leading-8 mb-10">
            Acompanhe a jornada profissional de nossa equipe através da presença na mídia.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-8 text-2xl font-semibold">
            <a
              href="https://www.instagram.com/ngs.advogada"
              target="_blank"
              rel="noopener noreferrer"
              className="text-navy hover:underline"
            >
              Instagram · ngs.advogada
            </a>
            <a
              href="https://www.threads.net/@ngs.advogada"
              target="_blank"
              rel="noopener noreferrer"
              className="text-navy hover:underline"
            >
              Threads · ngs.advogada
            </a>
          </div>
        </div>
      </section>

      {/* MISSÃO */}
      <section className="max-w-5xl mx-auto px-6 py-16">
        <h2 className="text-4xl font-bold mb-6">Missão</h2>
        <p className="text-xl leading-8">
          Oferecer uma advocacia que não apenas resolve litígios, mas que projeta segurança, ética e integridade por meio de políticas preventivas eficazes.
        </p>
      </section>

      {/* EQUIPE */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold mb-12 text-center">Equipe</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
            {/* Nathalie */}
            <div className="text-center">
              <img
                src={fotoNathalie}
                alt="Nathalie Guimarães dos Santos"
                className="mx-auto mb-6 h-64 w-48 object-cover rounded-xl shadow-lg"
              />
              <h3 className="text-2xl font-semibold">Nathalie Guimarães dos Santos</h3>
              <p className="text-lg mt-2">Advogada – Direito Penal e Compliance Penal (PUC-RS)</p>
              <p className="mt-2 text-base text-gray-600">nathalie.guimaraes@ngs.adv.br</p>
            </div>

            {/* Marília */}
            <div className="text-center">
              <img
                src="/assets/images/marilia.jpg"
                alt="Marília de Castro Cabral"
                className="mx-auto mb-6 h-64 w-48 object-cover rounded-xl shadow-lg"
              />
              <h3 className="text-2xl font-semibold">Marília de Castro Cabral</h3>
              <p className="text-lg mt-2">Advogada e Contadora – Direito Tributário e Auditoria</p>
              <p className="mt-2 text-base text-gray-600">marilia.cabral@ngs.adv.br</p>
            </div>

            {/* Ronaldo */}
            <div className="text-center">
              <img
                src="/assets/images/ronaldo.jpg"
                alt="Ronaldo Silva Lopes"
                className="mx-auto mb-6 h-64 w-48 object-cover rounded-xl shadow-lg"
              />
              <h3 className="text-2xl font-semibold">Ronaldo Silva Lopes</h3>
              <p className="text-lg mt-2">Advogado – Direito Penal e Processual Penal</p>
              <p className="mt-2 text-base text-gray-600">ronaldo.lopes@ngs.adv.br</p>
            </div>

            {/* Renata */}
            <div className="text-center">
              <img
                src="/assets/images/renata.jpg"
                alt="Renata Nunes"
                className="mx-auto mb-6 h-64 w-48 object-cover rounded-xl shadow-lg"
              />
              <h3 className="text-2xl font-semibold">Renata Nunes</h3>
              <p className="text-lg mt-2">Assistente Executiva e Relacionamento com o Cliente</p>
              <p className="mt-2 text-base text-gray-600">cliente@ngs.adv.br</p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
